<ng-container *transloco="let t">
  <app-holidays-dates-form [submitButtonText]="t('settings/editDaysOff')" (formSubmit)="editDaysOff($event)"></app-holidays-dates-form>
</ng-container>
